module.exports = __webpack_public_path__ + "img/certificate-green.74d02c9c.svg";